import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { OEComponents } from '@opportunityeducation/oe-web-common'

import { questIsPublished } from '../../../utils/review'

export default class StatusText extends Component {
  render() {
    const {
      quest,
      approvals,
      canSubmitForReview,
      isQuestCopyEditorOrQuestAuthorOrQuestManager,
      questIsInRejectedState,
      questIsInQualityReview,
      questHasAssignment,
      canSubmitButNotReady,
      questInDraftAfterRejection
    } = this.props

    const allCompleteNoApprovalsNoAssignment =
      canSubmitForReview &&
      !questInDraftAfterRejection &&
      approvals.length === 0 &&
      !questHasAssignment
    const notReadyNoApprovlsNoAssignment =
      canSubmitButNotReady && !questInDraftAfterRejection && !questHasAssignment
    const allCompleteAfterRejection =
      canSubmitForReview &&
      questInDraftAfterRejection &&
      approvals.length === 0 &&
      !questHasAssignment
    const notAllCompleteAfterRejection =
      canSubmitButNotReady && questInDraftAfterRejection && !questHasAssignment
    const inQualityReview =
      isQuestCopyEditorOrQuestAuthorOrQuestManager && questIsInQualityReview
    const questIsRejected =
      isQuestCopyEditorOrQuestAuthorOrQuestManager && questIsInRejectedState

    let primaryText = ''
    let secondaryText = ''
    let content
    // Need to hide the assignment message if there are current approvals, but not when the quest isn't ready for reviews
    if (
      questHasAssignment &&
      (approvals.length === 0 ||
        (approvals.length !== 0 && canSubmitButNotReady))
    ) {
      primaryText =
        'This quest is assigned to a reviewer and is not approved yet.'
      secondaryText = 'Keep an eye on it for feedback.'
    } else if (allCompleteNoApprovalsNoAssignment) {
      primaryText = 'All the required fields are now complete.'
      secondaryText = 'When ready, assign this quest to a Reviewer.'
    } else if (notReadyNoApprovlsNoAssignment) {
      primaryText = "What's next?"
      secondaryText =
        'Complete all required fields, including at least 1 activity. You may also assign this quest to a peer to get early feedback.'
    } else if (allCompleteAfterRejection) {
      primaryText = 'Make the changes you discussed with your Reviewer.'
      secondaryText = 'When ready, assign this quest to a Reviewer again.'
    } else if (notAllCompleteAfterRejection) {
      primaryText = 'Complete all required fields.'
      secondaryText = 'When ready, assign this quest to a Reviewer again.'
    }

    if (questIsPublished(quest)) {
      content = (
        <div>
          {'Published on '}
          <OEComponents.DateFormatter
            date={quest.published_compiled_quest.published_at}
            includeTime={false}
          />
          {' at '}
          <OEComponents.Time
            time={quest.published_compiled_quest.published_at}
          />
        </div>
      )
    } else if (inQualityReview) {
      content = (
        <div>
          <div className="primary">Internal reviews are complete. Onward!</div>
          <div className="tertiary">
            {'This quest moved on to Publication Review on '}
            <OEComponents.DateFormatter
              date={quest.reviewing_compiled_quest.created_at}
              includeTime={false}
            />
            {' at '}
            <OEComponents.Time
              time={quest.reviewing_compiled_quest.created_at}
            />
            .
          </div>
        </div>
      )
    } else if (questIsRejected) {
      content = <div>This quest needs edits before it can move on.</div>
    } else {
      content = this.renderText(primaryText, secondaryText)
    }

    return <div className="review-status-text">{content}</div>
  }

  renderText(primary, secondary) {
    return (
      <div>
        <div className="primary">{primary}</div>
        <div className="tertiary">{secondary}</div>
      </div>
    )
  }
}

StatusText.propTypes = {
  quest: PropTypes.object.isRequired,
  approvals: PropTypes.array.isRequired,
  canSubmitForReview: PropTypes.bool.isRequired,
  questIsInRejectedState: PropTypes.bool.isRequired,
  questIsInQualityReview: PropTypes.bool.isRequired,
  questHasAssignment: PropTypes.bool.isRequired,
  canSubmitButNotReady: PropTypes.bool.isRequired,
  questInDraftAfterRejection: PropTypes.bool.isRequired,
  isQuestCopyEditorOrQuestAuthorOrQuestManager: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/questbanner/StatusText.js